import type { ModalRequest } from './types'

type Listener = () => void

let queue: ModalRequest[] = []
const listeners = new Set<Listener>()

function emit() {
  for (const l of listeners) l()
}

export function subscribeModals(listener: Listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function getModalQueue(): ModalRequest[] {
  return queue
}

export function enqueueModal(request: ModalRequest) {
  queue = [...queue, request]
  emit()
}

function dequeueModal() {
  queue = queue.slice(1)
  emit()
}

export function dismissCurrent(result?: boolean | string | null) {
  const current = queue[0]
  if (!current) return
  if (current.kind === 'confirm') current.resolve(result === true)
  else if (current.kind === 'prompt') current.resolve(typeof result === 'string' ? result : null)
  else current.resolve()
  dequeueModal()
}
